import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from '../app/endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';
export const paymentApi = createApi({
    reducerPath: 'paymentApi',
    baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
    tagTypes: ['payment'],
    endpoints: builder => ({

        encPaymentString: builder.mutation({
            query: body => {
                return {
                    url: `${spotFinder.paymentController.encPaymentString}`,
                    method: 'POST',
                    headers: body.token ? { Authorization: `Bearer ${body.token}` } : {},
                    body: body.payload,
                };
            },
        }),
    }),
});


export const {
    useEncPaymentStringMutation,
} = paymentApi;
